import { render, staticRenderFns } from "./Multimedia.vue?vue&type=template&id=0e22c8a2&"
import script from "./Multimedia.vue?vue&type=script&lang=js&"
export * from "./Multimedia.vue?vue&type=script&lang=js&"
import style0 from "./Multimedia.vue?vue&type=style&index=0&id=0e22c8a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports